import createRoute       from '@widesk-ui/tools/createRoute';
import SubscriptionModel from '@models/account/SubscriptionModel';

export default createRoute.table('/subscriptions', 'account', 'SubscriptionTable', SubscriptionModel.localize('plural'));